import { useReportWebVitals as useReportWebVitalsBase } from 'next/web-vitals';

import { useAwsRum } from './awsrum';

export const NEXTJS_HYDRATION = 'Next.js-hydration';
export const NEXTJS_ROUTE_CHANGE_TO_RENDER = 'Next.js-route-change-to-render';
export const NEXTJS_RENDER = 'Next.js-render';

export const useReportWebVitals = () => {
    const awsRum = useAwsRum();
    useReportWebVitalsBase((metric) => {
        switch (metric.name) {
            case NEXTJS_HYDRATION:
                awsRum?.recordEvent(NEXTJS_HYDRATION, {
                    ...metric,
                });
                break;
            case NEXTJS_ROUTE_CHANGE_TO_RENDER:
                awsRum?.recordEvent(NEXTJS_ROUTE_CHANGE_TO_RENDER, {
                    ...metric,
                });
                break;
            case NEXTJS_RENDER:
                awsRum?.recordEvent(NEXTJS_RENDER, {
                    ...metric,
                });
                break;
            default:
                break;
        }
    });
};
